import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("La password deve avere almeno 6 caratteri"); return; }
    if (pw !== pw2) { toast.error("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reimpostata. Ora puoi accedere.");
      navigate("/login");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen grain flex items-center justify-center p-6 bg-[#0A0A0C]">
      <div className="w-full max-w-md bg-[#1C1C1F] border border-white/10 rounded-xl p-8">
        <div className="text-[#00E676] font-display font-black text-3xl tracking-tighter mb-1">Fuma c'anduma</div>
        <div className="flex items-center gap-2 text-zinc-300 mb-6"><ShieldCheck className="h-5 w-5 text-[#00E676]" /> Reimposta password</div>
        {!token ? (
          <p data-testid="reset-no-token" className="text-sm text-red-400">Link non valido o scaduto. Richiedi un nuovo link dalla schermata di accesso.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Nuova password</Label><Input data-testid="reset-new" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required className="bg-[#0A0A0C] border-white/10 mt-1.5" /></div>
            <div><Label>Conferma password</Label><Input data-testid="reset-confirm" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required className="bg-[#0A0A0C] border-white/10 mt-1.5" /></div>
            <Button data-testid="reset-submit" disabled={loading} className="w-full bg-[#00E676] text-black hover:bg-[#00c766] font-semibold rounded-full">{loading ? "Attendere…" : "Reimposta password"}</Button>
          </form>
        )}
        <button className="mt-6 text-xs text-zinc-500 hover:text-[#00E676]" onClick={() => navigate("/login")}>← Torna al login</button>
      </div>
    </div>
  );
}
